import axiosInstance from "./axiosInstance";
import { setUserData } from "../store/userSlice";
import { setEventData } from "../store/eventSlice";
import { ensureKeypair } from "../crypto/cryptoKeys";

function isValidUserObject(data) {
  return (
    data !== null &&
    data !== undefined &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    typeof data.uname === "string" &&
    data.uname.length > 0
  );
}

let activeUserFetchId = 0;

export function invalidateUserFetches() {
  activeUserFetchId += 1;
}

export async function registerSessionCryptoKey() {
  const { publicJwk } = await ensureKeypair();
  await axiosInstance.post(
    "crypto/register-key",
    { publicJwk },
    { withCredentials: true }
  );
}

function toEventList(value) {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return Object.values(value);
  return [];
}

export async function fetchAndSetUser(dispatch) {
  const fetchId = ++activeUserFetchId;

  const res = await axiosInstance.get("/user", { withCredentials: true });
  if (fetchId !== activeUserFetchId) {
    return null;
  }

  if (res.status === 200 && res.data) {
    dispatch(setUserData(res.data));
    return res.data;
  }

  return null;
}

export async function refreshSessionData(dispatch) {
  const fetchId = ++activeUserFetchId;

  const [userRes, eventsRes, exposureRes] = await Promise.all([
    axiosInstance.get("/user", { withCredentials: true }),
    axiosInstance.get("/events").catch(() => null),
    axiosInstance.get("/user/exposure").catch(() => null),
  ]);

  if (fetchId !== activeUserFetchId) {
    return null;
  }

  let refreshedUser = null;

  if (userRes?.status === 200 && isValidUserObject(userRes.data)) {
    refreshedUser = { ...userRes.data };

    if (exposureRes?.data?.exposure != null) {
      refreshedUser.header_exposure = exposureRes.data.exposure;
    }

    dispatch(setUserData(refreshedUser));
  }

  if (eventsRes?.data) {
    dispatch(
      setEventData({
        ...eventsRes.data,
        result: toEventList(eventsRes.data.result),
        horse: toEventList(eventsRes.data.horse),
        grey: toEventList(eventsRes.data.grey),
      })
    );
  }

  return refreshedUser;
}
